import { Button, Select } from 'antd';
import React, { useState } from 'react';
import { $SpaceCompact } from '../../../../../../ui/form/SpaceCompact';
import { useSetOptionsFromVariable } from './hooks/useSetOptionsFromVariable';

export interface ISetOptionsFromVariableInputProps {
  name: string;
}

/**
 * Piccolo form che permette di scegliere un set predeterminato di variabili anagrafica
 * e impostarle come opzioni del widget.
 */
export function SetOptionsFromVariableInput(
  props: ISetOptionsFromVariableInputProps,
) {
  const { name } = props;

  const { setOptionsFromVariable, variableReferences } =
    useSetOptionsFromVariable({ fieldName: name });

  const [selected, setSelected] = useState<string | null>();

  return (
    <$SpaceCompact block>
      <Select
        value={selected}
        allowClear
        showSearch
        style={{ width: '100%' }}
        placeholder="Seleziona la variabile di anagrafica da cui copiare le opzioni"
        optionFilterProp="label"
        options={variableReferences.options}
        onChange={value => {
          setSelected(value);
        }}
      />
      <Button
        type="primary"
        onClick={() => {
          if (!selected) return;
          setOptionsFromVariable(selected);
          setSelected(null);
        }}
        disabled={!selected}
      >
        Copia opzioni
      </Button>
    </$SpaceCompact>
  );
}
